import { render } from "./TrendRadarChart.vue?vue&type=template&id=cbff8834"
import script from "./TrendRadarChart.vue?vue&type=script&lang=js"
export * from "./TrendRadarChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__